import React, { memo } from 'react'
import type { PropsWithChildren } from 'react'
import Text from 'react-font'

import Title from './Title'
import './Title.module.css'

export interface ContentProps {
  title: string
  id: string
}

const Content: React.FC<PropsWithChildren<ContentProps>> = memo(
  ({ children, title, id }) => {
    return (
      <div
        id={id}
        className="container mx-auto bg-yellow-50 border-dashed border-2 border-teal-300 rounded-xl"
      >
        <Title>{title}</Title>
        <div className="text-justify p-6 text-teal-500 text-lg">
          <Text family="Nunito">
            <span>{children}</span>
          </Text>
        </div>
      </div>
    )
  },
)
Content.displayName = 'Title'

export default Content
